module.exports = __webpack_public_path__ + "static/media/Illus-BowlEmpty@2x.4d9468cb.png";